import React from 'react';

import { Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import {
  Article,
  Briefing,
  CommunityComment,
  FeaturedPartner,
  FeedUnits,
  LatestProArticles,
  Newsletter,
  UpcomingEvent,
} from '@interfaces/homepage';
import { Page } from '@tracking';

import MainFeed from '../../MainFeed';
import SideFeed from './SideFeed';

interface HomeProps {
  briefingNewsletter: Newsletter;
  communityComments: CommunityComment[];
  env: Env;
  featuredArticles?: Article[];
  feedContent: Article[] | (Article | Briefing)[];
  feedUnits?: FeedUnits;
  featuredPartners?: FeaturedPartner[];
  isGdprRequired: boolean;
  isWebview: boolean;
  latestProArticles: LatestProArticles[];
  recommendedArticles?: Article[];
  upcomingEvents: UpcomingEvent[];
  view: string;
}

const HomeContent = ({
  briefingNewsletter,
  communityComments,
  featuredArticles,
  feedContent,
  feedUnits,
  featuredPartners,
  latestProArticles,
  recommendedArticles,
  upcomingEvents,
  view,
}: HomeProps) => {
  const { Track } = useEventTracking({ page: Page.Homepage });
  return (
    <Track>
      <div className="px-0 sm:px-28">
        <div className="m-auto max-w-container-lg">
          <div className="flex">
            <div className="w-full md:max-w-[740px] md:pr-28 lg:max-w-[940px] lg:pr-56">
              <MainFeed
                featuredArticles={featuredArticles}
                feedContent={feedContent}
                feedUnits={feedUnits}
                view={view}
              />
            </div>
            <div className="hidden flex-1 border-0 border-l-[1px] border-solid border-grayscale-gray md:block md:pl-28 lg:pl-56">
              <SideFeed
                briefingNewsletter={briefingNewsletter}
                communityComments={communityComments}
                featuredPartners={featuredPartners}
                latestProArticles={latestProArticles}
                recommendedArticles={recommendedArticles}
                upcomingEvents={upcomingEvents}
              />
            </div>
          </div>
        </div>
      </div>
    </Track>
  );
};

export default HomeContent;
